import QueryStringAddon from 'wretch/addons/queryString';

import wretch from 'wretch';
import { UserType } from 'database';
import { providerUserTypes } from 'piramid-constants';

const BASE_URL = process.env.NEXT_PUBLIC_API_URL;

const publicRoutes = [
  '/claims/create',
  '/register',
  '/login',
  '/reset-password',
  '/forgot-password',
];

const resolvedBaseUrl =
  process.env.NEXT_RUNTIME === 'nodejs'
    ? process.env.NEXT_PUBLIC_API_URL
    : window.location.host.split('.')[0] !== 'provider'
    ? `/api`
    : process.env.NEXT_PUBLIC_API_URL;

export const httpClient = wretch(resolvedBaseUrl)
  .middlewares([
    (next) => (url, opts) => {
      try {
        return next(url, opts).then((res) => {
          if (res.status === 401 && typeof window !== 'undefined') {
            const isPublic = publicRoutes.some((route) =>
              window.location.pathname.includes(route),
            );

            if (!isPublic) {
              window.location.href = '/login';
            }
          }

          return res;
        });
      } catch (err) {
        return Promise.reject(err);
      }
    },
  ])
  .options({
    credentials: 'include',
    mode: 'cors',
  })
  .addon(QueryStringAddon);

export const fieldAdjusterClient = httpClient.headers({
  'x-user-type': 'field_adjuster' satisfies UserType,
});

export const vendorClient = httpClient.headers({
  'x-user-type': 'vendor' satisfies UserType,
});

// Provider-shared features (onboarding, engagements, profile, documents) belong
// to the Provider company and are reached by BOTH provider user types. The
// `x-user-type` header must match the logged-in user's type, otherwise the guard
// rejects the request (a field_adjuster has no vendor session → 401). Callers
// pass the type from `useAuth().user.type` (client) or the `user_type` cookie
// (SSR); it defaults to the vendor client.
export const providerClient = (type?: string) =>
  type === ('field_adjuster' satisfies UserType)
    ? fieldAdjusterClient
    : vendorClient;

// Public auth routes (login, forgot password, resend verification) run before a
// session exists. The email is globally unique, so the backend resolves the real
// user type and writes it to the `user_type` cookie; sending both provider types
// widens that lookup instead of making the user pick their own type.
export const providerAuthClient = httpClient.headers({
  'x-user-type': providerUserTypes.join(' '),
});
